import { ACCOUNT_MANAGE_COMPANY_SETTINGS } from "../../../constants/routes";
import { Icon } from "../../../components";
import { useMediaQuery } from "usehooks-ts";
import { useNavigate } from "react-router";
import { useSellarUser } from "../../../hooks";
import { DataButton } from "@sellar-io/components";
import { withSearchParams } from "../../../utils/withSearchParams";

export const Settings = ({ provider }: { provider: "two" | "hokodo" }) => {
  const { user: sellarUser } = useSellarUser();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width: 1200px)");
  const isUserLegalEntityAdmin =
    sellarUser && sellarUser.legalEntityAdminList.length > 0;

  if (isUserLegalEntityAdmin || sellarUser?.type === "admin") {
    if (!isDesktop) {
      return (
        <Icon
          icon="COG"
          size={0.7}
          onClick={() =>
            navigate(
              withSearchParams(ACCOUNT_MANAGE_COMPANY_SETTINGS, { provider }),
            )
          }
          className="cursor-pointer"
        />
      );
    }

    return (
      <DataButton
        border
        onClick={() =>
          navigate(
            withSearchParams(ACCOUNT_MANAGE_COMPANY_SETTINGS, { provider }),
          )
        }
        className="flex cursor-pointer items-center gap-2"
      >
        <Icon icon="COG" size={0.7} />
        Manage company
      </DataButton>
    );
  }

  return null;
};
